import angular from "angular";
import angularMoment from "angular-moment";

let mod = angular
    .module('kalendar', [angularMoment])
    .component('kalendar', {
        template: '<div id="{{$ctrl.key}}"></div>',
        controller: ['$document', '$timeout', 'moment', controller],
        bindings: {
            monthCount: '@',
            direction: '@',
            startDate: '<',
            endDate: '<',
            mode: '<',
            date1: '<',
            date2: '<',
            returnRes: '&'
        }
    });

function controller($document, $timeout, moment) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        let options = {
            format: 'YYYY-MM-DD',
            mode: $ctrl.mode || 'single',
            months: $ctrl.monthCount ? +$ctrl.monthCount : 1,
            weekStart: 1,
            direction: $ctrl.direction || 'today-future',
            useYearNav: false,
            endDate: $ctrl.endDate || null,
            rangeDelimiter: ',',
            multipleDelimiter: ',',
        };

        if ($ctrl.startDate) {
            let startDate = ($ctrl.startDate instanceof window.moment) ? $ctrl.startDate : moment($ctrl.startDate);
            options.blackout = function (date) {
                return startDate.isAfter(date);
            }
        }

        let selectedDates = [];

        if ($ctrl.date1) {
            selectedDates.push($ctrl.date1);
        }

        if ($ctrl.date2) {
            selectedDates.push($ctrl.date2);
        }

        options.selected = selectedDates;

        $ctrl.key = generateId();

        $ctrl.canReturnResult = true;

        $timeout(function () {

            $ctrl.kalendar = new window.Kalendae($ctrl.key, options);

            $ctrl.kalendar.subscribe('date-clicked', function () {
                $ctrl.canReturnResult = true;
            });

            $ctrl.kalendar.subscribe('change', function () {
                if ($ctrl.canReturnResult) {
                    $ctrl.returnRes({dates: $ctrl.kalendar.getSelectedAsText()});
                }
            });

        }, 500);
    };

    function generateId() {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 10; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

    $ctrl.$onChanges = function (changes) {

        if (changes.mode && !changes.mode.isFirstChange()) {
            $ctrl.kalendar.settings.mode = $ctrl.mode;
        }

        let changed =
            (changes.date1 && !changes.date1.isFirstChange()) ||
            (changes.date2 && !changes.date2.isFirstChange());

        if (changed) {
            let selected = $ctrl.kalendar.getSelectedAsText();
            selected[0] = $ctrl.date1;
            selected[1] = $ctrl.date2;
            $ctrl.canReturnResult = false;
            $ctrl.kalendar.setSelected(selected);
        }

    };

}

export default mod.name;


// WEBPACK FOOTER //
// ./resources/assets/modules/kalendar/kalendar.js